/**
 * annunci.js — quando qualcosa cambia in una linguetta, la testata lo
 * deve sapere.
 *
 * IL PROBLEMA, DETTO UNA VOLTA SOLA
 * La scheda del paziente carica in un colpo solo, all'apertura, i dati
 * che mostra in testata e nei riquadri di riepilogo: allergie, procedure,
 * promemoria, fotografie, anamnesi. Poi il medico entra in una linguetta
 * e li cambia — toglie un'allergia, chiude un promemoria, registra una
 * procedura — e la testata resta quella di prima, fino al prossimo
 * caricamento della pagina.
 *
 * Sui conteggi e' fastidioso. Sulla FASCIA DELLE ALLERGIE e' un difetto
 * clinico: mostra un'allergia che il medico ha appena smentito, ed e'
 * peggio di non mostrarne nessuna. E' lo stesso difetto che aveva la
 * fascia delle controindicazioni, corretta il 15 settembre 2026 con
 * questo stesso meccanismo.
 *
 * UN EVENTO E NON FUNZIONI PASSATE DI MANO IN MANO
 * Fra chi salva e chi disegna la testata ci sono due o tre componenti
 * che della cosa non sanno niente e non devono impararla. Passare un
 * `onQualcosaCambiato` attraverso tutti vuol dire modificarli tutti ogni
 * volta che si aggiunge un riquadro.
 *
 * PERCHE' NON UN EVENTO SOLO
 * Un unico «qualcosa e' cambiato» costringerebbe a rileggere tutto — sei
 * richieste — ogni volta che si chiude un promemoria. Ogni annuncio dice
 * COSA e' cambiato, e chi ascolta rilegge solo quello.
 */

const EVENTI = {
    anamnesi:   'rimedichub:anamnesi-cambiata',
    procedure:  'rimedichub:procedure-cambiate',
    alert:      'rimedichub:alert-cambiati',
    foto:       'rimedichub:foto-cambiate',
    scheda:     'rimedichub:scheda-salvata',
    /* L'agenda cambia anche da fuori: il riquadro dei ritardi segna un
       paziente presente, e la griglia deve accorgersene senza che
       qualcuno la ricarichi a mano. */
    agenda:     'rimedichub:agenda-cambiata',
};

function annuncia(chiave) {
    const nome = EVENTI[chiave];
    if (!nome) return;
    /* Non deve mai far fallire il salvataggio che lo ha chiamato: un
       avviso che non parte lascia un conteggio vecchio, un'eccezione qui
       farebbe credere che il salvataggio non sia andato. */
    try { window.dispatchEvent(new CustomEvent(nome)); } catch (e) { /* niente */ }
}

export const annunciaAnamnesiCambiata  = () => annuncia('anamnesi');
export const annunciaProcedureCambiate = () => annuncia('procedure');
export const annunciaAlertCambiati     = () => annuncia('alert');
export const annunciaFotoCambiate      = () => annuncia('foto');
export const annunciaSchedaSalvata     = () => annuncia('scheda');
export const annunciaAgendaCambiata    = () => annuncia('agenda');

/**
 * Aggancia un ascoltatore e restituisce la funzione che lo stacca.
 * Va usata dentro un useEffect, restituendola: senza staccarlo, ogni
 * riapertura della scheda ne aggiunge uno e la stessa lettura parte
 * cinque volte.
 */
export function ascolta(chiave, azione) {
    const nome = EVENTI[chiave];
    if (!nome) return () => {};
    window.addEventListener(nome, azione);
    return () => window.removeEventListener(nome, azione);
}

export { EVENTI };
